import { gql } from "@apollo/client";

export const GET_ALL_LAND_INFO = `
query GET_ALL_LAND_INFO {
  landInfos {
    id
    coordinates {
      x
      y
    }
    tierName
    price
    district
    isShiboshiZone
    isRoad
    reserved
    primaryRoadName
    secondaryRoadName
    intersection
    hubName
    owner
    isMinted
    bidCount
    bidWinner
  }
}
`

export const GET_LAND_INFO_BY_ID = (id: string) => {
  const queryString = `
 query getLandInfoById {
  landInfoById(id: "${id}") {
    id
    coordinates {
      x
      y
    }
    district
    hubName
    intersection
    isMinted
    isRoad
    isShiboshiZone
    owner
    price
    primaryRoadName
    reserved
    secondaryRoadName
    tierName
    bidCount
    bidWinner
  }
}
`
  return (queryString)
}


export const GET_LANDS_OWNED_BY_ADDRESS = (address: string) => {
  const queryString = `
query getLandsOwnedByAddress {
  landInfos(where: {owner_eq: "${address}"}) {
    isMinted
    id
    coordinates {
      x
      y
    }
    district
    hubName
    intersection
    isRoad
    isShiboshiZone
    noBidAllowedOnLand
    owner
    price
    primaryRoadName
    reserved
    secondaryRoadName
    tierName
    bidCount
    bidWinner
  }
}
`
  return (queryString)
}

export const GET_TRANSACTIONS_HISTORY = (walletAddress: string) => {
  const queryString = `
      query getTransactions {
          landInfos(where: {owner_eq: "${walletAddress}"}) {
              id
              coordinates { x y }
              owner
              price
              isBoughtWithShib
          }
      }`
  return (queryString)
}

export const GET_ETH_USD_RATE = `
query GET_ETH_USD_RATE {
  bundleById(id: "1") {
    ethPrice
  }
}
`
export const GET_DERIVED_ETH_RATE = `
query GET_DERIVED_ETH_RATE {
  tokenById(id: "0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce") {
    derivedETH
  }
}
`


export const GET_LAND_AGGREGATE_DATA = (tier: string, quantity: number) => {
  const queryString = `
  query getLandAggregateData {
  landInfos(where: {isMinted_eq: false, tierName_eq: "${tier}"}, limit: ${quantity}) {
    id
    price
    coordinates {
      x
      y
    }
    isMinted
    }
  }   
  `
  return (queryString)
}
